import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { UserService } from 'src/app/core/common-services/user.services';
import { AuthenticationService } from 'src/app/core/data-services/authentication.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { environment } from 'src/environments/environment';
import { NotificationSidebarComponent } from '../notification-sidebar/notification-sidebar.component';

@Component({
  selector: 'app-nav',
  templateUrl: './top-nav-bar.component.html',
  styleUrls: ['./top-nav-bar.component.css'],
})
export class TopNavBarComponent implements OnInit {
  userName = '';
  currentLang = 'ar';
  unreadCount = 0;
  @Input() isRtl = false;
  @Input() showSideNav!: TemplateRef<any>;

  @ViewChild('notifSidebar') notifSidebar!: NotificationSidebarComponent;

  constructor(
    private readonly userService: UserService,
    private readonly authenticationService: AuthenticationService,
    public readonly languageService: LanguageService
  ) {}

  ngOnInit() {
    this.currentLang = this.languageService.currentLanguage || 'ar';
    this.isRtl = this.currentLang === 'ar';

    if (!this.languageService.currentLanguage) {
      this.languageService.setLanguage(this.currentLang);
    }

    const userData = localStorage.getItem('currentUser');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        this.userName = user.englishName || user.arabicName || user.email || '';
      } catch {
        this.userName = '';
      }
    }

    setTimeout(() => this.notifSidebar?.loadUnreadCount());
  }

  logout() {
    this.authenticationService.logout().subscribe({
      next: () => this.userService.logout(),
      error: () => this.userService.logout(),
    });
  }

  switchLang() {
    const newLang = this.currentLang === 'en' ? 'ar' : 'en';
    this.languageService.setLanguage(newLang);
    this.currentLang = this.languageService.currentLanguage;
    this.isRtl = this.currentLang === 'ar';
    globalThis.location.reload();
  }

  openNotifications() {
    this.notifSidebar.open();
  }

  get imgUrlFromStorage(): string {
    const userData = localStorage.getItem('currentUser');
    if (userData) {
      try {
        return JSON.parse(userData).imgUrl || '';
      } catch {
        return '';
      }
    }
    return '';
  }

  get profileImageDisplay(): string {
    const path = this.imgUrlFromStorage;
    if (!path) return 'assets/image/user.svg';
    return this.toProfileImageUrl(path) || 'assets/image/user.svg';
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/image/user.svg';
  }

  private toProfileImageUrl(path: string): string {
    if (!path) return '';
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    if (/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(path)) {
      return path;
    }
    const envAny = environment as any;
    const base: string = envAny.ossBaseUrl ?? envAny.appCDNConfig?.CDN ?? '';
    if (!base) return path;
    return base.endsWith('/') ? base + path : base + '/' + path;
  }
}
